define("command-palette/utils/command-helpers", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.bold = bold;
  _exports.waitFor = waitFor;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Converts a string to bold HTML by wrapping it in <strong> tags.
   */
  function bold(str) {
    if (!str) {
      return str;
    }
    return `<strong>${str}</strong>`;
  }

  /**
   * Waits for an event with the given name to be dispatched on the window.
   * Useful in commands that depend on some async action (like rendering a
   * page) to complete in order to perform their action.
   *
   * @param eventName The name of the event to wait for.
   * @param timeout The number of milliseconds to wait before timing out.
   *
   * @returns A promise that always resolves. If the event is dispatched before
   * the timeout, the promise resolves with `ok: true` but if the timeout is
   * reached before the event is dispatched, the promise resolves with `ok: false`.
   */
  function waitFor(eventName) {
    let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10_000;
    return new Promise(resolve => {
      window.dispatchEvent(new CustomEvent(`trigger-${eventName}`));
      const timeoutId = setTimeout(() => {
        resolve({
          ok: false,
          error: {
            timeout: true,
            eventName
          }
        });
        window.removeEventListener(eventName, listener);
      }, timeout);
      const listener = event => {
        clearTimeout(timeoutId);
        window.removeEventListener(eventName, listener);
        resolve({
          ok: true,
          data: {
            eventName,
            eventData: event.detail,
            event
          }
        });
      };
      window.addEventListener(eventName, listener);
    });
  }
});